export default {
  incomeItemCode: '',
  incomeQty: '',
  updatedBy: '',
  incomeBranch: '',
};
